import { render, staticRenderFns } from "./AdminConsent.vue?vue&type=template&id=e4ae3cf6"
import script from "./AdminConsent.vue?vue&type=script&lang=js"
export * from "./AdminConsent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e4ae3cf6')) {
      api.createRecord('e4ae3cf6', component.options)
    } else {
      api.reload('e4ae3cf6', component.options)
    }
    module.hot.accept("./AdminConsent.vue?vue&type=template&id=e4ae3cf6", function () {
      api.rerender('e4ae3cf6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/AdminConsent.vue"
export default component.exports